import React from "react"
import { createContext } from "use-context-selector"
import { useAppContextState } from "../../@hooks"
import { getAppUserData } from "../../@utils"

const AppMainHotelsContext = createContext(null)

export function AppMainHotelsProvider({children}) {
    const { mainHotelsSectionData, userId } = getAppUserData()
    const data = mainHotelsSectionData || {}
    let idMainHotel = null

    if (!window.location.href.includes('logout')) {
        // "All hotels" mode only exists in Packages — ignore the flag on other routes
        // so a user entering Competition/Parity/Home directly (F5 or link) gets their
        // real selected hotel resolved from localStorage instead of a null state.
        const isPackagesPage = window.location.pathname.includes('/packages')
        const isAllMode = isPackagesPage && localStorage.getItem('packagesAllHotelsMode') === 'true'
        if (isAllMode) {
            idMainHotel = null
        } else {
            const stored = localStorage.getItem('selectedMainHotel')
            const storedId = stored && stored !== 'null' ? parseInt(stored) : null
            idMainHotel = storedId || data[userId]?.['hotels']?.idHotel?.[0] || null
        }
    }

    const storedLabel = localStorage.getItem('selectedMainHotelLabel')
    const initialState = {
        mainHotels: idMainHotel,
        mainHotelsLabel: storedLabel || null,
        isSetHotel: false,
        forceRemount: null,
        isChangingHotel: false
    }
    const { state, replaceState, resetState, updateState } = useAppContextState(initialState)



    return <AppMainHotelsContext.Provider value={{state, replaceState, updateState, resetState}}>
        {children}
    </AppMainHotelsContext.Provider>

}

export default AppMainHotelsContext